'use client';

import Icon from '@/components/ui/AppIcon';

export default function GeneralQuestionsForm() {
  const handleRedirect = () => {
    window.open('https://stan.store/maryambellakbira', '_blank');
  };

  return (
    <div className="bg-card p-8 md:p-12 rounded-3xl border border-border shadow-xl">
      <div className="flex items-center gap-3 mb-8">
        <div className="p-3 bg-accent/10 rounded-xl">
          <Icon name="ChatBubbleLeftRightIcon" size={28} className="text-accent" />
        </div>
        <div>
          <h2 className="text-3xl font-bold text-foreground">General Questions</h2>
          <p className="text-sm text-muted-foreground">Have a question? Get in touch</p>
        </div>
      </div>

      <div className="space-y-6">
        <p className="text-muted-foreground text-lg">
          Have a general question or inquiry? Click below to send us a message and we'll respond within 24-48 hours.
        </p>

        <div className="bg-accent/5 p-6 rounded-xl space-y-3">
          <h3 className="font-semibold text-foreground flex items-center gap-2">
            <Icon name="InformationCircleIcon" size={20} className="text-accent" />
            What you can ask about:
          </h3>
          <ul className="space-y-2 text-muted-foreground ml-7">
            <li>• Collaboration opportunities</li>
            <li>• Partnership inquiries</li>
            <li>• Media requests</li>
            <li>• General information</li>
            <li>• Other questions</li>
          </ul>
        </div>

        <button
          onClick={handleRedirect}
          className="w-full px-8 py-4 bg-accent text-accent-foreground rounded-full font-bold text-sm uppercase tracking-wider hover:bg-accent/90 transition-all hover:scale-105 shadow-glow-coral inline-flex items-center justify-center gap-2"
        >
          <Icon name="PaperAirplaneIcon" size={20} />
          <span>Contact Us</span>
          <Icon name="ArrowRightIcon" size={16} />
        </button>

        <p className="text-xs text-muted-foreground text-center">
          You'll be redirected to our contact platform to send your message
        </p>
      </div>
    </div>
  );
}